<template >
  <b-container fluid>
    

  <b-row class="mt-1 mb-5">
    <b-col cols="12" class="mt-5 mb-4 ">
       <b-form-checkbox v-model="verCambiarFecha" @change="actualizaDatos"><h5>Edición del recibo</h5></b-form-checkbox> 
    
    </b-col>
    
    
    <b-col v-if="verCambiarFecha">
      <b-tabs >
        <b-tab title="Fecha" v-if="catalogFormas.cambiarFechaRecibo">
          <b-row class="mt-3">
             <b-col>
                Fecha
                <b-form-input  type="date"  v-model="fechaRecibo"  />          
            </b-col>
            <b-col>
              Hora
                <b-form-timepicker v-model="horaRecibo" locale="en"></b-form-timepicker>
            </b-col>
            <b-col>
              .
              <b-button block @click="updateRecibo(1)" variant="success" >
                <b-spinner v-if="isConsultando"></b-spinner>
                <strong v-if="isConsultando">&nbsp;&nbsp; Procesando . . .</strong>
                <strong v-if="!isConsultando">Procesar </strong>
              </b-button>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Forma de pago" v-if="catalogFormas.cambiarFormaPago">
          <b-row class="mt-3">
            <b-col>
              Forma de pago
              <b-form-select :options="optionsFormaPago" v-model="formaPago"  />          
            </b-col>
            <b-col>
              No. tarjeta
                <b-form-input  placeholder="no. tarjeta" v-model="numTarjeta"  />          
            </b-col>
            <b-col>
              Banco emisor
                <b-form-input  placeholder="banco emisor" v-model="bancoEmisor"  />          
            </b-col>
            <b-col>
              Banco receptor
                <b-form-input placeholder="banco receptor" v-model="bancoReceptor"  />          
            </b-col>
            <b-col>
              Autorización
                <b-form-input placeholder="autorizacion" v-model="autorizacion"  />          
            </b-col>
            
            <b-col>
              .
              <b-button block @click="updateRecibo(2)" variant="success" >
                <b-spinner v-if="isConsultando"></b-spinner>
                <strong v-if="isConsultando">&nbsp;&nbsp; Procesando . . .</strong>
                <strong v-if="!isConsultando">Procesar </strong>
              </b-button>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Liquidación" v-if="catalogFormas.cambiarLiquidacionRecibo">
          <b-row class="mt-3">
            <b-col>
              Año
              <b-form-input type="number" v-model="año"></b-form-input>
            </b-col>
            <b-col>
              Mes inicial
              <b-form-select type="number" v-model="mesIni" :options="meses"></b-form-select>
            </b-col>
            <b-col>
              Mes final
              <b-form-select type="number" v-model="mesFin" :options="meses"></b-form-select>
            </b-col>
            <b-col>
              .
              <b-button block @click="updateRecibo(3)" variant="success">
                <b-spinner v-if="isConsultando"></b-spinner>
                <strong v-if="isConsultando">&nbsp;&nbsp; Procesando . . .</strong>
                <strong v-if="!isConsultando">Procesar </strong>
              </b-button>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
      
  </b-container>
</template>

<script>
  import axios from 'axios'
  //import { minLength, maxLength, between, helpers, requiredIf } from 'vuelidate/lib/validators'
  import { mapState} from 'vuex'
  import { server, checkAuth, getPostConfig, handledError} from '@/axios-tools'

  
  export default {
    data(){
      return {
        folRec:'',
        verCambiarFecha:false,
        fechaRecibo:'',
        horaRecibo:'',
        formaPago:'',
        numTarjeta:'',
        bancoEmisor:'',
        bancoReceptor:'',
        autorizacion:'',
        año:2000,
        mesIni : 1,
        mesFin : 12,
        ctaContable : -1,
        meses:[1,2,3,4,5,6,7,8,9,10,11,12],
        optionsFormaPago:["Efectivo", "Cheque", "Transferencia", "Crédito", "Débito", "Por definir"],
      }
    },
    computed: {
    ...mapState ({
    isConsultando: state => state.formas.isConsultando,
    token: state => state.login.token,
    msgErrorFormasSimple: state => state.formas.msgErrorFormasSimple,
    catalogFormas: state => state.formas.catalogFormas,
    })
  },
  props:['transacciones'],
    methods: {
      updateRecibo(opcion){
        let model ={
          opcion:opcion,
          folRec:this.folRec,
          fecha:this.fechaRecibo,
          hora:this.horaRecibo,
          cuentaContable:this.ctaContable,
          formaPago:this.formaPago,
          numTarjeta:this.numTarjeta,
          bancoEmisor:this.bancoEmisor,
          bancoReceptor:this.bancoReceptor,
          autorizacion:this.autorizacion,
          mesInicial:this.mesIni,
          mesFinal:this.mesFin,
          año:this.año
        }

        if(!this.isConsultando &&  checkAuth(this.$router, this.$store)){
            this.$store.commit("updateIsConsultando", true);
            axios(
                getPostConfig(server.editarPago, model, this.token, {})
            )
            .then(res => {

                this.$store.commit("updateFormas", []);
                this.$store.commit("updateIsFormCollapse", false);
                this.$store.commit("updateTotalRecibosMonto", "");
                
                this.$store.commit("updateIsConsultando", false);
                alert(res.data)

            }).catch(err => {
                this.$store.commit("updateIsConsultando", false);
                handledError(err, server.editarPago, this.$router, this.$store);
            });
        }
      },
      actualizaDatos(){
        let t = this.transacciones[0];
        this.folRec=t.folio;
        this.fechaRecibo=t.fecha.substring(0, 10).replaceAll('/','-');
        this.horaRecibo=t.fecha.substring(11, 19).replaceAll('/','-');
        this.formaPago=t.formaPago;
        this.numTarjeta=t.numTarjeta;
        this.bancoEmisor=t.bancoEmisor;
        this.bancoReceptor=t.bancoReceptor;
        this.autorizacion=t.autorizacion;
        this.año=parseInt(t.año);
        this.mesIni =parseInt(t.mesIni);
        this.mesFin =parseInt(t.mesFin);
        this.ctaContable = t.cuentaContable;
      }
    },
    validations: {
      
    }
  }
</script>
<style>
div.error {color: red; font-size: 80%;}
</style>